import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.assign";

var scope_0 = require('D:/work/BC_Supermarket/bc-supermarket-docs-docz/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/094b259c63d539116813bc62dd53a5e9.js').default;

var scope_1 = require('D:/work/BC_Supermarket/bc-supermarket-docs-docz/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/157f82f95e0d5dc98000ae82e84061fe.js').default;

var scope_2 = require('D:/work/BC_Supermarket/bc-supermarket-docs-docz/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1970366a8c100bb8e42caab4bfa24659.js').default;

var scope_3 = require('D:/work/BC_Supermarket/bc-supermarket-docs-docz/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/5cbe4b0b9a44325ac307c3a9665b4a54.js').default;

var scope_4 = require('D:/work/BC_Supermarket/bc-supermarket-docs-docz/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/cf1d68b4d5ff4a15adf40c249c60388e.js').default;

var scope_5 = require('D:/work/BC_Supermarket/bc-supermarket-docs-docz/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d53bc6eb29b2d7b989a042423d5380c0.js').default;

var scope_6 = require('D:/work/BC_Supermarket/bc-supermarket-docs-docz/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e95c582fe2f1eea61af26ce1fd686214.js').default;

var scope_7 = require('D:/work/BC_Supermarket/bc-supermarket-docs-docz/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f59f29fa9c807ab9e84244e8f6603d66.js').default;

export default Object.assign({}, scope_0, scope_1, scope_2, scope_3, scope_4, scope_5, scope_6, scope_7);